require('./insuranceRequestWizardPricing.scss');

// @ vendors
const React = require('react');
const PropTypes = require('prop-types');
const classnames = require('classnames');

// @ helpers
const { formatText, getLanguage } = require('core/i18n').i18n;
const { getFormattedString } = require('utilities/currencyHelper');
const { toFirstUppercase } = require('utilities/stringHelper');
const { formatPercentage } = require('../../../insuranceUtilities/payments');

// @ commons
const OKCalculationWaffer = require('components/commons/OKCalculationWaffer/OKCalculationWaffer');
const { LoadingSection } = require('commonsComponents/loadingSection');

// @ constants
const { EURO_TEXT, PERCENTAGE_SYMBOL } = require('constants/index');
const { PAYMENT_TYPE, text } = require('../../../insuranceConstants/insuranceRequestHome');

class InsuranceRequestWizardPricing extends React.Component {
    constructor(props) {
        super(props);
    }

    formatAmount(amount) {
        return getFormattedString({
            amount: amount,
            currency: EURO_TEXT,
            decimalsLength: 2
        })
    }

    getImport() {
        const { immPricing, plan, paymentType } = this.props;

        let amount = immPricing.getIn([paymentType.toLowerCase(), plan.toLowerCase(), 'totalImport']);

        return amount;
    }

    getDiscountPercentage() {
        const { immPricing, plan, paymentType } = this.props;

        const paymentTypeKey = paymentType.toLowerCase();
        const planKey = plan.toLowerCase();

        const selectedPlanImport = immPricing.getIn([paymentTypeKey, planKey, 'totalImport']);
        const biannualImport = immPricing.getIn(['biannual', planKey, 'totalImport']);
        const quarterlyImport = immPricing.getIn(['quarterly', planKey, 'totalImport']);
        const originalPrice = quarterlyImport ? quarterlyImport : biannualImport;

        if (originalPrice) {
            const percentage = (originalPrice - selectedPlanImport) / originalPrice * 100;
            const percentageText = formatPercentage(percentage);
            const isPercentageOverLimit = percentage > 1;

            if (isPercentageOverLimit) {
                return `${percentageText} ${PERCENTAGE_SYMBOL}`
            }
        }
    }

    buildExtraInfo() {
        const { paymentType } = this.props;

        let infoItems = [];

        const discountPercentage = this.getDiscountPercentage();

        if (discountPercentage) {
            const paymentTypeText = formatText(`insuranceRequestHome-step4paymentType${toFirstUppercase(paymentType)}`);

            infoItems.push({
                title: `${text().DISCOUNT} ${paymentTypeText.toLowerCase()}`,
                bodyText: discountPercentage
            });
        }

        return infoItems;
    }

    buildRelatedExtraInfo() {
        const { immPricing, plan, paymentType } = this.props;

        const paymentTypeKey = paymentType.toLowerCase();
        const planKey = plan && plan.toLowerCase();

        let infoItems = [];
        const isEnglishLanguage = getLanguage() === "en";

        if (paymentType === PAYMENT_TYPE.ANNUAL) {
            const discountPercentage = this.getDiscountPercentage();

            if (discountPercentage) {
                const paymentTypeText = formatText(`insuranceRequestHome-step4paymentType${toFirstUppercase(paymentType)}`);

                infoItems.push({
                    title: `${text().DISCOUNT_RELATED} ${paymentTypeText.toLowerCase()}`,
                    bodyText: isEnglishLanguage ? discountPercentage.replace(',', '.') : discountPercentage
                });
            }
        }
        else {
            const titleFirstInstallment = text().FIRST_IMPORT[paymentType];
            const titleSuccesiveInstallments = text().SUCCESSIVE_IMPORT[paymentType];
            const firstImport = immPricing.getIn([paymentTypeKey, planKey, 'firstImport'])
            const successiveImport = immPricing.getIn([paymentTypeKey, planKey, 'succesiveReceiptsImport'])
            const firstImportFormatAmount = this.formatAmount(firstImport);
            const successiveImporttFormatAmount = this.formatAmount(successiveImport);

            infoItems = [
                {
                    title: titleFirstInstallment,
                    bodyText: isEnglishLanguage ? firstImportFormatAmount.replace(',', '.') : firstImportFormatAmount
                },
                {
                    title: titleSuccesiveInstallments,
                    bodyText: isEnglishLanguage ? successiveImporttFormatAmount.replace(',', '.') : successiveImporttFormatAmount
                }
            ];
        }

        return infoItems;
    }

    render() {
        const { isLoading } = this.props;

        if (isLoading) {
            return <LoadingSection />;
        }

        const infoItems = this.buildRelatedExtraInfo();

        const wafferClass = classnames('insurance-request-wizard-pricing__waffer', {
            'insurance-request-wizard-pricing__waffer--no-items': infoItems.length === 0,
            'insurance-request-wizard-pricing__waffer--saving': infoItems.length === 1,
            'insurance-request-wizard-pricing__waffer--items': infoItems.length > 1
        });

        const primeTitleKey = 'step4relatedPaymentPrime';
        const primeTitle = formatText(`insuranceRequestHome-${primeTitleKey}`);
        const primeAmount = this.getImport();

        return (
            <div className="insurance-request-wizard-pricing">
                <OKCalculationWaffer
                    className={wafferClass}
                    itemsList={infoItems}
                    outstandedLabel={primeTitle}
                    outstandedText={this.formatAmount(primeAmount)}
                />
            </div>
        );
    }
}

InsuranceRequestWizardPricing.propTypes = {
    immPricing: PropTypes.object.isRequired,
    plan: PropTypes.string.isRequired,
    paymentType: PropTypes.string.isRequired,
    isRelated: PropTypes.bool,
    isLoading: PropTypes.bool
};

InsuranceRequestWizardPricing.defaultProps = {
    isRelated: false,
    isLoading: false,
    paymentType: '',
    plan: ''
};

module.exports = InsuranceRequestWizardPricing;
